<template>
	<v-container class="fs-organizer-container">
		<v-layout justify-space-around>
			<v-flex md4>
				<v-card class="elevation-12">
					<v-toolbar
						dark
						color="primary"
					>
						<v-toolbar-title>Пожалуйста, авторизуйтесь</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-card-text>
						<v-form>
							<v-text-field
								prepend-icon="person"
								name="login"
								label="Логин"
								type="text"
								v-model="login"
								:error="formError"
								required
							></v-text-field>
							<v-text-field
								autocomplete
								id="password"
								prepend-icon="lock"
								name="password"
								label="Пароль"
								type="password"
								v-model="password"
								:error="formError"
								:error-messages="formErrorMessage"
								required
							></v-text-field>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click="loginRequest"
						>Войти</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	name: 'AuthIndex',
	data() {
		return {
			login: null,
			password: null,
			superAdminStartPage: 'MainSuperAdminView',
			formError: false,
			formErrorMessage: ''
		}
	},
  mounted() {
    if ("".endsWith) {
      // eslint-disable-next-line no-unused-vars
      for (let [key, _] of Object.entries(localStorage)) {
        if (key.endsWith("ViewFilters")) {
          console.log('clear', key)
          localStorage.removeItem(key)
        }
      }
    }
  },
  methods: {
		loginRequest() {
			this.$store
				.dispatch('LOGIN', {
					username: this.login,
					password: this.password
				})
				.then(() => {
					this.formError = false
					this.$router.push({ name: this.superAdminStartPage })
				})
				.catch(error => {
					this.formError = true
					this.formErrorMessage = error.response.data.message
				})
		}
	}
}
</script>
